import React, { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { getJsonValue } from "../utils/localstorage.util";

const CanAccessGame = () => {
  const navigate = useNavigate();
  const team = getJsonValue("TEAM");
  useEffect(() => {
    if (!team) navigate("/");
  }, [team]);
  return <Outlet />;
};

export default CanAccessGame;
